import React, { useEffect, useState } from 'react';
import { getPendingCount, onPendingChanged } from '../utils/pendingSubmissions';
import { useIsMobile } from '../hooks/useIsMobile';
import LayoutDesktop from './LayoutDesktop';
import LayoutMobile from './LayoutMobile';

const Layout: React.FC = () => {
  const isMobile = useIsMobile();
  const [pendingCount, setPendingCount] = useState(getPendingCount);

  useEffect(() => {
    return onPendingChanged(() => setPendingCount(getPendingCount()));
  }, []);

  return isMobile ? (
    <LayoutMobile pendingCount={pendingCount} />
  ) : (
    <LayoutDesktop pendingCount={pendingCount} />
  );
};

export default Layout;
